module.exports = __webpack_public_path__ + "static/img/meiyeBdNew.0aed26c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meiyeBdNew.jpg
// module id = /6dY
// module chunks = 0